module.exports = __webpack_public_path__ + "img/2-grey.38a5be3b.png";